import { Property1, Property2, Property3, Property4, Property5, Property6 } from "../Assets/Images";

export const MarketplaceCardDetails = [
    {
        ImageUrl: Property1,
        Title: 'Modern Villa',
        Place: 'Sunnydale Estates, California',
        PropertyClass: 'Luxury Residential',
        TargetedInvestorIRR: '12%',
        TargetedAverageCashYield: '8%',
        TargetedEquityMultiple: '1.7x',
        MinimumInvestment: '$50,000',
        urlLink: 'https://example-real-estate-platform.com/property1'
    },
    
    {
        ImageUrl: Property2,
        Title: 'Downtown Loft',
        Place: 'Metropolis City, New York',
        PropertyClass: 'Urban Residential',
        TargetedInvestorIRR: '10.5%',
        TargetedAverageCashYield: '7.5%',
        TargetedEquityMultiple: '1.5x',
        MinimumInvestment: '$40,000',
        urlLink: 'https://example-real-estate-platform.com/property2'
    },
    
    {
        ImageUrl: Property3,
        Title: 'Seaside Condo',
        Place: 'Oceanfront Paradise, Florida',
        PropertyClass: 'Beachfront Residential',
        TargetedInvestorIRR: '11.8%',
        TargetedAverageCashYield: '7.2%',
        TargetedEquityMultiple: '1.6x',
        MinimumInvestment: '$60,000',
        urlLink: 'https://example-real-estate-platform.com/property3'
    },
    
    {
        ImageUrl: Property4,
        Title: 'Tech Hub Office Space',
        Place: 'Innovation District, Silicon Valley',
        PropertyClass: 'Commercial Office',
        TargetedInvestorIRR: '9.5%',
        TargetedAverageCashYield: '6.8%',
        TargetedEquityMultiple: '1.4x',
        MinimumInvestment: '$75,000',
        urlLink: 'https://example-real-estate-platform.com/property4'
    },
    
    {
        ImageUrl: Property5,
        Title: 'Historic Brownstone',
        Place: 'Old Town Charm, Boston',
        PropertyClass: 'Heritage Residential',
        TargetedInvestorIRR: '11.2%',
        TargetedAverageCashYield: '7.0%',
        TargetedEquityMultiple: '1.8x',
        MinimumInvestment: '$55,000',
        urlLink: 'https://example-real-estate-platform.com/property5'
    },
    
    {
        ImageUrl: Property6,
        Title: 'Industrial Warehouse',
        Place: 'Commerce Hub, Dallas',
        PropertyClass: 'Industrial',
        TargetedInvestorIRR: '8.7%',
        TargetedAverageCashYield: '6.5%',
        TargetedEquityMultiple: '1.3x',
        MinimumInvestment: '$30,000',
        urlLink: 'https://example-real-estate-platform.com/property6'
    }
];
